
// @ts-nocheck
import locale_bg_46json_0528d91f from "#nuxt-i18n/0528d91f";
import locale_cs_46json_1d0922a8 from "#nuxt-i18n/1d0922a8";
import locale_da_46json_4aec0a26 from "#nuxt-i18n/4aec0a26";
import locale_de_46json_5c5d9b29 from "#nuxt-i18n/5c5d9b29";
import locale_de_45CH_46json_f56db7d7 from "#nuxt-i18n/f56db7d7";
import locale_el_46json_6ffd5182 from "#nuxt-i18n/6ffd5182";
import locale_en_46json_2f3fc6f3 from "#nuxt-i18n/2f3fc6f3";
import locale_es_46json_ea3b4e59 from "#nuxt-i18n/ea3b4e59";
import locale_fr_46json_f30330dc from "#nuxt-i18n/f30330dc";
import locale_hr_46json_5993e583 from "#nuxt-i18n/5993e583";
import locale_hu_46json_9f42ed67 from "#nuxt-i18n/9f42ed67";
import locale_it_46json_cc477b31 from "#nuxt-i18n/cc477b31";
import locale_ja_46json_c6c9065b from "#nuxt-i18n/c6c9065b";
import locale_ko_46json_9e4dd786 from "#nuxt-i18n/9e4dd786";
import locale_lv_46json_d9828d69 from "#nuxt-i18n/d9828d69";
import locale_nl_46json_4770c7c9 from "#nuxt-i18n/4770c7c9";
import locale_no_46json_2ede87df from "#nuxt-i18n/2ede87df";
import locale_pl_46json_dfc3dee1 from "#nuxt-i18n/dfc3dee1";
import locale_pt_46json_14804783 from "#nuxt-i18n/14804783";
import locale_ro_46json_23ce2638 from "#nuxt-i18n/23ce2638";
import locale_ru_46json_9948b74d from "#nuxt-i18n/9948b74d";
import locale_sk_46json_31d77331 from "#nuxt-i18n/31d77331";
import locale_sl_46json_44773fc6 from "#nuxt-i18n/44773fc6";
import locale_sq_46json_d467db97 from "#nuxt-i18n/d467db97";
import locale_sr_46json_20645373 from "#nuxt-i18n/20645373";
import locale_sv_46json_51ba8059 from "#nuxt-i18n/51ba8059";
import locale_tr_46json_9151d22a from "#nuxt-i18n/9151d22a";
import locale_uk_46json_93e8a4a1 from "#nuxt-i18n/93e8a4a1";
import locale_zh_46json_fc6d4e32 from "#nuxt-i18n/fc6d4e32";

export const localeCodes =  [
  "bg",
  "cs",
  "da",
  "de",
  "de-CH",
  "el",
  "en",
  "es",
  "fr",
  "hr",
  "hu",
  "it",
  "ja",
  "ko",
  "lv",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sq",
  "sr",
  "sv",
  "tr",
  "uk",
  "zh"
]

export const localeLoaders = {
  bg: [
    {
      key: "locale_bg_46json_0528d91f",
      load: () => Promise.resolve(locale_bg_46json_0528d91f),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_1d0922a8",
      load: () => Promise.resolve(locale_cs_46json_1d0922a8),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_4aec0a26",
      load: () => Promise.resolve(locale_da_46json_4aec0a26),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_5c5d9b29",
      load: () => Promise.resolve(locale_de_46json_5c5d9b29),
      cache: true
    }
  ],
  "de-CH": [
    {
      key: "locale_de_45CH_46json_f56db7d7",
      load: () => Promise.resolve(locale_de_45CH_46json_f56db7d7),
      cache: true
    }
  ],
  el: [
    {
      key: "locale_el_46json_6ffd5182",
      load: () => Promise.resolve(locale_el_46json_6ffd5182),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_2f3fc6f3",
      load: () => Promise.resolve(locale_en_46json_2f3fc6f3),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_ea3b4e59",
      load: () => Promise.resolve(locale_es_46json_ea3b4e59),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_f30330dc",
      load: () => Promise.resolve(locale_fr_46json_f30330dc),
      cache: true
    }
  ],
  hr: [
    {
      key: "locale_hr_46json_5993e583",
      load: () => Promise.resolve(locale_hr_46json_5993e583),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_9f42ed67",
      load: () => Promise.resolve(locale_hu_46json_9f42ed67),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_cc477b31",
      load: () => Promise.resolve(locale_it_46json_cc477b31),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_c6c9065b",
      load: () => Promise.resolve(locale_ja_46json_c6c9065b),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_9e4dd786",
      load: () => Promise.resolve(locale_ko_46json_9e4dd786),
      cache: true
    }
  ],
  lv: [
    {
      key: "locale_lv_46json_d9828d69",
      load: () => Promise.resolve(locale_lv_46json_d9828d69),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_4770c7c9",
      load: () => Promise.resolve(locale_nl_46json_4770c7c9),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_2ede87df",
      load: () => Promise.resolve(locale_no_46json_2ede87df),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_dfc3dee1",
      load: () => Promise.resolve(locale_pl_46json_dfc3dee1),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_14804783",
      load: () => Promise.resolve(locale_pt_46json_14804783),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_23ce2638",
      load: () => Promise.resolve(locale_ro_46json_23ce2638),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_9948b74d",
      load: () => Promise.resolve(locale_ru_46json_9948b74d),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json_31d77331",
      load: () => Promise.resolve(locale_sk_46json_31d77331),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46json_44773fc6",
      load: () => Promise.resolve(locale_sl_46json_44773fc6),
      cache: true
    }
  ],
  sq: [
    {
      key: "locale_sq_46json_d467db97",
      load: () => Promise.resolve(locale_sq_46json_d467db97),
      cache: true
    }
  ],
  sr: [
    {
      key: "locale_sr_46json_20645373",
      load: () => Promise.resolve(locale_sr_46json_20645373),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_51ba8059",
      load: () => Promise.resolve(locale_sv_46json_51ba8059),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_9151d22a",
      load: () => Promise.resolve(locale_tr_46json_9151d22a),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_93e8a4a1",
      load: () => Promise.resolve(locale_uk_46json_93e8a4a1),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_fc6d4e32",
      load: () => Promise.resolve(locale_zh_46json_fc6d4e32),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/92e4b3ad" /* webpackChunkName: "config_i18n_46config_46ts_92e4b3ad" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "bg",
      name: "Bulgarian",
      language: "bg-BG",
      files: [
        {
          path: "/app/locales/bg.json",
          cache: undefined
        }
      ]
    },
    {
      code: "cs",
      name: "Czech",
      language: "cs-CZ",
      files: [
        {
          path: "/app/locales/cs.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      name: "Danish",
      language: "da-DK",
      files: [
        {
          path: "/app/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "German",
      language: "de-DE",
      files: [
        {
          path: "/app/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de-CH",
      name: "German (Switzerland)",
      language: "de-CH",
      files: [
        {
          path: "/app/locales/de-CH.json",
          cache: undefined
        }
      ]
    },
    {
      code: "el",
      name: "Greek",
      language: "el-GR",
      files: [
        {
          path: "/app/locales/el.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      language: "en-US",
      files: [
        {
          path: "/app/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Spanish",
      language: "es-ES",
      files: [
        {
          path: "/app/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "French",
      language: "fr-FR",
      files: [
        {
          path: "/app/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hr",
      name: "Croatian",
      language: "hr-HR",
      files: [
        {
          path: "/app/locales/hr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      name: "Hungarian",
      language: "hu-HU",
      files: [
        {
          path: "/app/locales/hu.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italian",
      language: "it-IT",
      files: [
        {
          path: "/app/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      name: "Japanese",
      language: "ja-JP",
      files: [
        {
          path: "/app/locales/ja.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      name: "Korean",
      language: "ko-KR",
      files: [
        {
          path: "/app/locales/ko.json",
          cache: undefined
        }
      ]
    },
    {
      code: "lv",
      name: "Latvian",
      language: "lv-LV",
      files: [
        {
          path: "/app/locales/lv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      name: "Dutch",
      language: "nl-NL",
      files: [
        {
          path: "/app/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      name: "Norwegian",
      language: "no-NO",
      files: [
        {
          path: "/app/locales/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      name: "Polish",
      language: "pl-PL",
      files: [
        {
          path: "/app/locales/pl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "Portuguese",
      language: "pt-PT",
      files: [
        {
          path: "/app/locales/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro",
      name: "Romanian",
      language: "ro-RO",
      files: [
        {
          path: "/app/locales/ro.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Russian",
      language: "ru-RU",
      files: [
        {
          path: "/app/locales/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sk",
      name: "Slovak",
      language: "sk-SK",
      files: [
        {
          path: "/app/locales/sk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sl",
      name: "Slovenian",
      language: "sl-SI",
      files: [
        {
          path: "/app/locales/sl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sq",
      name: "Albanian",
      language: "sq-AL",
      files: [
        {
          path: "/app/locales/sq.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sr",
      name: "Serbian",
      language: "sr-RS",
      files: [
        {
          path: "/app/locales/sr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      name: "Swedish",
      language: "sv-SE",
      files: [
        {
          path: "/app/locales/sv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      name: "Turkish",
      language: "tr-TR",
      files: [
        {
          path: "/app/locales/tr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      name: "Ukrainian",
      language: "uk-UA",
      files: [
        {
          path: "/app/locales/uk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      name: "Chinese",
      language: "zh-CN",
      files: [
        {
          path: "/app/locales/zh.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: false
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "bg",
    name: "Bulgarian",
    language: "bg-BG",
    files: [
      {
        path: "/app/locales/bg.json",
        cache: undefined
      }
    ]
  },
  {
    code: "cs",
    name: "Czech",
    language: "cs-CZ",
    files: [
      {
        path: "/app/locales/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    name: "Danish",
    language: "da-DK",
    files: [
      {
        path: "/app/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "German",
    language: "de-DE",
    files: [
      {
        path: "/app/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de-CH",
    name: "German (Switzerland)",
    language: "de-CH",
    files: [
      {
        path: "/app/locales/de-CH.json",
        cache: undefined
      }
    ]
  },
  {
    code: "el",
    name: "Greek",
    language: "el-GR",
    files: [
      {
        path: "/app/locales/el.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    language: "en-US",
    files: [
      {
        path: "/app/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Spanish",
    language: "es-ES",
    files: [
      {
        path: "/app/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "French",
    language: "fr-FR",
    files: [
      {
        path: "/app/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hr",
    name: "Croatian",
    language: "hr-HR",
    files: [
      {
        path: "/app/locales/hr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    name: "Hungarian",
    language: "hu-HU",
    files: [
      {
        path: "/app/locales/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italian",
    language: "it-IT",
    files: [
      {
        path: "/app/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "Japanese",
    language: "ja-JP",
    files: [
      {
        path: "/app/locales/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "Korean",
    language: "ko-KR",
    files: [
      {
        path: "/app/locales/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "lv",
    name: "Latvian",
    language: "lv-LV",
    files: [
      {
        path: "/app/locales/lv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Dutch",
    language: "nl-NL",
    files: [
      {
        path: "/app/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    name: "Norwegian",
    language: "no-NO",
    files: [
      {
        path: "/app/locales/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "Polish",
    language: "pl-PL",
    files: [
      {
        path: "/app/locales/pl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Portuguese",
    language: "pt-PT",
    files: [
      {
        path: "/app/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    name: "Romanian",
    language: "ro-RO",
    files: [
      {
        path: "/app/locales/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Russian",
    language: "ru-RU",
    files: [
      {
        path: "/app/locales/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sk",
    name: "Slovak",
    language: "sk-SK",
    files: [
      {
        path: "/app/locales/sk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sl",
    name: "Slovenian",
    language: "sl-SI",
    files: [
      {
        path: "/app/locales/sl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sq",
    name: "Albanian",
    language: "sq-AL",
    files: [
      {
        path: "/app/locales/sq.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sr",
    name: "Serbian",
    language: "sr-RS",
    files: [
      {
        path: "/app/locales/sr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    name: "Swedish",
    language: "sv-SE",
    files: [
      {
        path: "/app/locales/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    name: "Turkish",
    language: "tr-TR",
    files: [
      {
        path: "/app/locales/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    name: "Ukrainian",
    language: "uk-UA",
    files: [
      {
        path: "/app/locales/uk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    name: "Chinese",
    language: "zh-CN",
    files: [
      {
        path: "/app/locales/zh.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/